import { render, staticRenderFns } from "./LabelretourPage.vue?vue&type=template&id=52180a2a"
import script from "./LabelretourPage.vue?vue&type=script&lang=js"
export * from "./LabelretourPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports